import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { LinkCard } from './LinkCard';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#30333b',
  },
  outerGrid: {
    minHeight: '100vh',
    minWidth: '100vw',
    padding: '0 80px',
  },
});

const App = () => {
  const classes = useStyles();

  return (
    <main className={classes.root}>
      <Grid
        container
        className={classes.outerGrid}
        alignItems='center'
        direction='column'
        justify='center'
      >
        <Grid item>
          <Grid
            container
            alignContent='center'
            justify='space-evenly'
            spacing={10}
          >
            <Grid item>
              <LinkCard
                caption='at work'
                href='https://jordanatwork.com'
                imageUrl={
                  'https://jordanatwork.com/markdown-is-the-worst/da-kraplak-727110-unsplash_hu3d03a01dcc18bc5be0e67db3d8d209a6_1047252_800x0_resize_q75_lanczos.jpg'
                }
              />
            </Grid>
            <Grid item>
              <LinkCard
                caption='at rest'
                href={'https://jordanatrest.com'}
                imageUrl={
                  'https://jordanatrest.com/post/the-smoothie/featured_hu3d03a01dcc18bc5be0e67db3d8d209a6_2435541_680x500_fill_q90_lanczos_smart1.jpg'
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </main>
  );
};

export default App;
